import { numberUtils } from '@/utils/number'
import { dict2list } from '@/utils/index'
import { operateMaxShowLength } from '@/store/dict/config'
import {
  BILL_STATUS,
  BILL_STATUS_TEXT,
  INVOICING_STATUS_TEXT,
  INVOICING_STATUS,
} from './const'
import {
  getServiceFeeInvoice,
  getInvoiceInfo,
  confirmBill,
  applyInvoice,
} from '@/api/financeApi/feeCenter'
import moment from 'moment'
import { downloadFileByUrl } from '@/utils/download'

// 表格配置
export const tableConfig = (
  judgePermission,
  { openDrawer, goDetail },
) => {
  return {
    formData: {
      list: [
        {
          el: 'date-picker',
          itemConfig: {
            label: '账单月份',
            prop: 'dm',
          },
          elConfig: {
            placeholder: '请选择',
            type: 'month',
            format: 'yyyy-MM',
            valueFormat: 'yyyy-MM',
            clearable: true,
            defaultValue: '',
            pickerOptions: {
              disabledDate: (time) => {
                return moment(time).isAfter(moment())
              },
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '费用类型',
            prop: 'amountType',
          },
          elConfig: {
            placeholder: '请选择',
            clearable: true,
            filterable: false,
            options: {
              label: 'name',
              value: 'code',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '账单状态',
            prop: 'billStatus',
          },
          elConfig: {
            placeholder: '请选择',
            filterable: false,
            options: {
              label: 'label',
              value: 'value',
              list: dict2list(BILL_STATUS_TEXT),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '开票状态',
            prop: 'invoicingStatus',
          },
          elConfig: {
            placeholder: '请选择',
            filterable: false,
            options: {
              label: 'label',
              value: 'value',
              list: dict2list(INVOICING_STATUS_TEXT),
            },
          },
        },
      ],
    },
    tableData: {
      columns: [
        {
          name: 'companyEntityName',
          columnProps: {
            label: '企业主体全称',
            prop: 'companyEntityName',
            width: 120,
          },
        },
        {
          name: 'dm',
          columnProps: {
            label: '账单月份',
            prop: 'dm',
            width: 120,
          },
        },
        {
          name: 'amountTypeName',
          columnProps: {
            label: '费用类型',
            prop: 'amountTypeName',
          },
        },
        {
          name: 'amount',
          columnProps: {
            label: '技术服务费总金额（元）',
            prop: 'amount',
            width: 180,
          },
          getText: ({ row }) => numberUtils.format(row.amount),
        },
        {
          name: 'paymentAmount',
          columnProps: {
            label: '已付款总金额（元）',
            prop: 'paymentAmount',
            width: 160,
          },
          getText: ({ row }) => numberUtils.format(row.paymentAmount),
        },
        {
          name: 'remainingAmount',
          columnProps: {
            label: '剩余应付金额（元）',
            prop: 'remainingAmount',
            width: 160,
          },
          getText: ({ row }) => numberUtils.format(row.remainingAmount),
        },
        {
          name: 'billStatus',
          columnProps: {
            label: '账单状态',
            prop: 'billStatus',
            width: 100,
          },
          getText: ({ row }) => BILL_STATUS_TEXT[row.billStatus],
        },
        {
          name: 'invoicingStatus',
          columnProps: {
            label: '开票状态',
            prop: 'invoicingStatus',
            width: 80,
          },
          getText: ({ row }) => {
            let text = INVOICING_STATUS_TEXT[row.invoicingStatus]
            if (row.invoicingStatus === INVOICING_STATUS.INVOICE_FAILED) {
              text += `（${row.invoicingFailReason}）`
            }
            return text
          },
        },
        {
          name: 'fileName',
          columnProps: {
            label: '账单明细文件',
            prop: 'fileName',
            width: 120,
          },
          render: ({ row }) => {
            const { fileName, fileUrl } = row
            if (!fileName || !fileUrl) return '--'
            return (
              <a href={fileUrl} target="_blank">
                {fileName}
              </a>
            )
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const optBtns = []
            const { billStatus, invoicingStatus } = row
            if (
              judgePermission('serviceFeeInvoicePaymentDetailBtn') &&
              [BILL_STATUS.PAYING, BILL_STATUS.COMPLETE].includes(billStatus)
            ) {
              optBtns.push({
                name: 'detail',
                label: '付款明细',
                action: () => goDetail(row),
              })
            }
            if (
              judgePermission('serviceFeeInvoiceConfirmBill') &&
              billStatus === BILL_STATUS.TO_CONFIRM
            ) {
              optBtns.push({
                name: 'confirm',
                label: '确认账单',
                action: () =>
                  openDrawer(DRAWER_OPERATIONS.CONFIRM_BILL.name, row),
              })
            }
            if (
              judgePermission('serviceFeeInvoiceApplyInvoice') &&
              billStatus === BILL_STATUS.COMPLETE &&
              [
                INVOICING_STATUS.NOT_INVOICED,
                INVOICING_STATUS.INVOICE_FAILED,
              ].includes(invoicingStatus)
            ) {
              optBtns.push({
                name: 'applyInvoice',
                label: '申请开票',
                action: () =>
                  openDrawer(DRAWER_OPERATIONS.APPLY_INVOICE.name, row),
              })
            }
            if (
              judgePermission('serviceFeeInvoiceDownloadInvoiceBtn') &&
              invoicingStatus === INVOICING_STATUS.INVOICED
            ) {
              optBtns.push({
                name: 'downloadInvoice',
                label: '下载发票',
                action: () =>
                  downloadFileByUrl(row.invoiceFileUrl, null, {
                    target: '_blank',
                  }),
              })
            }
            return optBtns
          },
          type: 'operate',
        },
      ],
      pagination: {
        pageSizes: [10, 20, 30, 50],
      },
      apiFn: getServiceFeeInvoice,
    },
    isShowDepartment: false,
  }
}

// 确认账单配置
const confirmConfig = [
  {
    key: 'dm',
    label: '账单月份',
  },
  {
    key: 'amountTypeName',
    label: '费用类型',
  },
  {
    key: 'amount',
    label: '技术服务费总金额（元）',
    getText: (value) => numberUtils.format(value),
  },
]

// 申请开票配置
const invoiceConfig = [
  {
    key: 'invoiceHeader',
    label: '发票抬头',
  },
  {
    key: 'taxpayerIdentificationNum',
    label: '纳税人识别号',
  },
  {
    key: 'invoiceType',
    label: '开票类型',
  },
  {
    key: 'invoiceInfo',
    label: '开票商品',
  },
  {
    key: 'amount',
    label: '开票金额（元）',
    getText: (value) => numberUtils.format(value),
  },
  {
    key: 'mail',
    label: '收票邮箱',
  },
  {
    key: 'bankName',
    label: '开户银行',
  },
  {
    key: 'bankNum',
    label: '银行账号',
  },
  {
    key: 'addr',
    label: '注册地址',
  },
  {
    key: 'phone',
    label: '注册电话',
  },
]

/**
 * 抽屉操作
 * @property name：String 操作标识
 * @property title：Function 抽屉标题
 * @property columns：展示项配置
 * @property show：Function 抽屉展示生命周期
 * @property submitApi：Function 抽屉提交API
 * @property successText：String 操作成功提示
 */
export const DRAWER_OPERATIONS = {
  // 确认账单
  CONFIRM_BILL: {
    name: 'CONFIRM_BILL',
    getTitle: (bill) =>
      `确认账单（${bill.dm.replace('-', '年')}月${
        bill?.amountTypeName
      }）`,
    columns: confirmConfig,
    show: (billId) => {
      return getServiceFeeInvoice({ billId }).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          return data.items?.[0]
        }
      })
    },
    submitApi: confirmBill,
    successText: '账单确认成功',
  },
  // 申请开票
  APPLY_INVOICE: {
    name: 'APPLY_INVOICE',
    getTitle: () => '请确认开票信息',
    columns: invoiceConfig,
    show: (billId) => {
      return getInvoiceInfo(billId).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          return data
        }
      })
    },
    submitApi: applyInvoice,
    successText: '申请成功，开票处理中，请稍后刷新页面查看状态',
  },
}
